<template>
    <div>
        <loading :loading="loading" spinner-class="justify-center">
            <div v-for="i in data" :key="i.id" class="card p-3 mb-3">
                <div class="flex items-center">
                    <div class="w-10 h-10 rounded-full relative flex-shrink-0 mr-3">
                        <img :src="i.user.images !== '' && i.user.images !== null ? i.user.images : require('@/assets/images/avatars/avatar-1.jpg')" alt="" class="absolute h-full rounded-full w-full">
                    </div>
                    <div>
                        <h5 class="font-bold">{{ i.title }}</h5>
                        <p class="text-sm">{{ i.description }}</p>
                    </div>
                </div>
            </div>
            <div v-if="data.length < 1" class="card p-3">
                <p class="text-center mb-0">Tidak ada history skripsi</p>
            </div>
        </loading>
    </div>
</template>

<script>
    import { mapActions } from 'vuex'

    export default {
        name: 'HistorySkripsi',
        data () {
            return {
                data: [],
                loading: false
            }
        },
        methods: {
            ...mapActions('skripsi', { fetchHistory: 'fetchHistory' })
        },
        mounted () {
            console.log('mounted')
            this.loading = true
            this.fetchHistory()
                .then(res => {
                    this.data = res
                })
                .finally(() => {
                    this.loading = false
                })
        }
    }
</script>
